import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import { t } from "../../../../../core/translate";
import { cloud } from "@vitalsource/vstui/colors";
import AvailabilityMessage from "../../../book/simplepanel/availability-message";
import { selectors as bridgeSelectors } from "../../../../../../redux/bridge";
import { styledMedia } from "../../../../../components/mediaquery/breakpoints";
import PropTypes from "prop-types";
import { UnsafeHtml } from "../../../../../components/mixins";

const Wrapper = styled.div`
  background-color: ${cloud.getShade(2)};
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;
const OuterContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  -wekbit-overflow-scrolling: touch;
  padding: 33px 26px 233px;

  ${styledMedia.medium`
    padding: 19px 16px 200px;
  `}
`;

const ContentContainer = styled.div`
  padding: 18px;
  background: white;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  font-size: 1.4rem;
  width: 365px;

  &:not(:last-child) {
    margin-bottom: 14px;
  }

  p {
    margin-top: 0;
    margin-bottom: 5px;
  }
`;
const TextHeader = styled.h3`
  font-weight: 600;
  padding: 0;
  margin: 0 0 5px;
`;
const TextEntry = styled.div`
  margin-bottom: 12px;
  text-transform: capitalize;
`;

const SimpleBookDetailsContainer = ({ isbn, asset, publishDate }) => {
  return (
    <Wrapper>
      <OuterContainer>
        {<AvailabilityMessage isbn={isbn} />}
        <ContentContainer>
          {asset.publisher && asset.publisher.length > 0 && (
            <span>
              <TextHeader>{t("library.book.publisher")}</TextHeader>
              <TextEntry>{asset.publisher}</TextEntry>
            </span>
          )}
          {asset.kind && asset.kind.length > 0 && (
            <span>
              <TextHeader>{t("library.book.format")}</TextHeader>
              <TextEntry>{asset.kind}</TextEntry>
            </span>
          )}
          {publishDate && (
            <span>
              <TextHeader>{t("library.book.published")}</TextHeader>
              <TextEntry>{publishDate}</TextEntry>
            </span>
          )}
          {asset.vbid && asset.vbid.length > 0 && (
            <span>
              <TextHeader>{t("library.book.vbid")}</TextHeader>
              <TextEntry>{asset.vbid}</TextEntry>
            </span>
          )}
          {asset.description && asset.description.length > 0 && (
            <span>
              <TextHeader>{t("library.book.description")}</TextHeader>
              <UnsafeHtml>{asset.description}</UnsafeHtml>
            </span>
          )}
        </ContentContainer>
      </OuterContainer>
    </Wrapper>
  );
};

SimpleBookDetailsContainer.propTypes = {
  isbn: PropTypes.string.isRequired
};

const mapStateToProps = (state, props) => ({
  asset: bridgeSelectors.getAsset(state, props.isbn),
  publishDate: bridgeSelectors.getPublishDate(state, props.isbn),
  hasUnlimitedAccess: bridgeSelectors.hasUnlimitedAccess(state, props.isbn)
});

export default withTheme(
  connect(mapStateToProps, null)(SimpleBookDetailsContainer)
);
